import { FilterTypes } from '../../constants/initialFilters';

// Function to build URL parameters from FilterTypes
const buildQueryParams = (filters: FilterTypes | null): string => {
  // If filters are null, clear the hash and return the base URL
  if (!filters) {
    const newUrl = `${window.location.pathname}`; // Just the path without any hash
    window.history.pushState({}, '', newUrl);

    // Manually trigger a state update since pushState doesn't trigger an event
    window.dispatchEvent(new HashChangeEvent('hashchange'));

    return ''; // No hash parameters
  }
  const hashParams: URLSearchParams = new URLSearchParams();

  // Add filters back to URL parameters
  if (filters.vehicleType) {
    hashParams.set('type', filters.vehicleType);
  }

  if (filters.modelFamily && filters.modelFamily.length > 0) {
    hashParams.set('modelFamily', filters.modelFamily.join(','));
  }

  if (filters.bodyType && filters.bodyType.length > 0) {
    hashParams.set('body-style', filters.bodyType.join(','));
  }

  if (filters.price && filters.price.length > 0) {
    hashParams.set('price', filters.price.join(':'));
  }

  if (filters.modelYear && filters.modelYear.length > 0) {
    hashParams.set('year', filters.modelYear.join(','));
  }

  if (filters.power && filters.power.length > 0) {
    hashParams.set('power', filters.power.join(':'));
  }

  if (filters.mileage && filters.mileage.length > 0) {
    hashParams.set('mileage', filters.mileage.join(':'));
  }

  if (filters.gearBox && filters.gearBox.length > 0) {
    hashParams.set('gearbox', filters.gearBox.join(','));
  }

  if (filters.drivetrain && filters.drivetrain.length > 0) {
    hashParams.set('drivetrain', filters.drivetrain.join(','));
  }

  if (filters.fuelType && filters.fuelType.length > 0) {
    hashParams.set('fuel-type', filters.fuelType.join(','));
  }

  if (filters.wheelSize && filters.wheelSize.length > 0) {
    hashParams.set('wheel-size', filters.wheelSize.join(','));
  }

  if (filters.exteriorColor && filters.exteriorColor.length > 0) {
    hashParams.set('colour', filters.exteriorColor.join(','));
  }

  if (filters.interiorColor && filters.interiorColor.length > 0) {
    hashParams.set('interior', filters.interiorColor.join(','));
  }

  if (filters.trimLine && filters.trimLine.length > 0) {
    hashParams.set('trimline', filters.trimLine.join(','));
  }

  if (filters.nonAudi && filters.nonAudi.length > 0) {
    hashParams.set('nonAudi', filters.nonAudi);
  }

  if (filters.otherMakes && filters.otherMakes.length > 0) {
    hashParams.set('otherMakes', filters.otherMakes.join(','));
  }

  if (filters.nonAudiModels && filters.nonAudiModels.length > 0) {
    hashParams.set('nonAudiModels', filters.nonAudiModels.join(','));
  }

  if (filters.availableInMonths !== undefined && filters.availableInMonths !== null) {
    hashParams.set('availableInMonths', filters.availableInMonths.toString());
  }

  if (filters.usedInventoryType && filters.usedInventoryType.length > 0) {
    hashParams.set('usedInventoryType', filters.usedInventoryType);
  }

  if (filters.preused && filters.preused.length > 0) {
    hashParams.set('preused', filters.preused.join(','));
  }

  // if (filters.partnerDealers && filters.partnerDealers.length > 0) {
  //   hashParams.set('dealer', filters.partnerDealers.join(','));
  // }

  // Construct the new URL: path + hash fragment
  const newUrl = `${window.location.pathname}#${hashParams.toString()}`;

  // Update the URL without reloading the page
  window.history.pushState({}, '', decodeURIComponent(newUrl));

  // Manually trigger a state update since pushState doesn't trigger an event
  // window.dispatchEvent(new HashChangeEvent('hashchange'));

  return newUrl;
};

export default buildQueryParams;
